import React from 'react';
import { CircularProgress, Box } from '@mui/material';

const LoadingOverlay = ({ isLoading }) => {
  if (!isLoading) return null;
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      position="fixed"
      top={0}
      left={0}
      bottom={0}
      right={0}
      zIndex={9999}
      bgcolor="rgba(0, 0, 0, 0.0)"
    >
      <CircularProgress color="primary" />
    </Box>
  );
};

export default LoadingOverlay;
